import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationService,
         SuccessResponse,
         getCompanyName,
         LogoComponent,
         CopyToClipboard,
} from '@sheerid/jslib';

interface StepSuccessProps {
    verificationService: VerificationService;
}


const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {

    const hasLogo = verificationService.programTheme.logoUrl ? true : false;

    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    { hasLogo ?
                        <LogoComponent verificationService={verificationService} />
                        :
                        <img
                            className="sid-l-lead-image"
                            alt="design element"
                            src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-check.svg"
                        />
                    }
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                        `Here is your personal coupon code.
                        It is unique to you and can only be used once.`
                    } />
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {rewardCode}
            </div>

            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                <CopyToClipboard
                    textToCopy={rewardCode}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy Coupon code" />
                </CopyToClipboard>
            </div>
            <div className="sid-success-redirect-link">
                <FormattedHTMLMessage id="step.success.returnToHsn" defaultMessage={`
                    Return to <a href='https://www.hsn.com/' target=_parent>HSN.com</a> to continue shopping
                `} />
            </div>
            <div className="sid-footer sid-success-footer-one sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage={`
                    We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com
                `} />
            </div>

            <div className="sid-footer sid-success-footer-two sid-success-footer-disclaimer sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage id="step.success.disclaimer" defaultMessage={`
                    This Coupon can be used on only one item and can only be used once by its recipient
                    and is valid for 15% off a single item with maximum savings of $25 from
                    <a href='https://www.hsn.com/' target=_blank>HSN.COM</a>. This coupon is
                    only valid for select verified healthcare occupations. Coupon number is
                    non-transferable. Coupons must be applied when order is placed. Excludes
                    shipping & handling, sales tax, and clearance items and can only be applied
                    to the first shipment of Auto-Ship items. The use of this coupon may disqualify
                    the order from inclusion in other promotional offers or discounts. Coupons
                    cannot be applied to or combined with other coupons. Coupon is not valid for
                    Arrow Sewing, Bose, charitable contributions, Dyson, Fitbit, gift cards, wines
                    and alcohol, Janome, Samsung large appliances, selected footwear, the iRobot
                    Roomba 880. We reserve the right to cancel orders when unexpected coupon system
                    errors occur or in the case of abuse, misuse or fraud in connection with the
                    coupon number. Offer is valid 3/11/2020 - 12/31/2020. Coupon Expires on
                    12/31/2020 at 11:59 PM ET.
                `} />
            </div>

            <div className="sid-footer sid-success-footer-two sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage id="step.success.verificationOnly"
                    defaultMessage={`
                        SheerID handles verification only.
                        Now that you've been approved, please direct all questions about the
                        promotion terms and/or code use to {companyName} customer service.
                    `}
                    values={{
                        companyName: getCompanyName(verificationService.programTheme),
                    }}
                />
            </div>
        </div>
    );
};

export { StepSuccessComponent };
